<template>
  <div class="product-listing-top">
    <span class="product-listing-top__title">Showing <b>{{ countProducts }}</b> Results</span>
    <div class="product-listing-top__pils-wrap">
      <!-- <PartPills title="Caravaggio"/> -->
      <PartPills :activeFilters="activeFilters"/>
    </div>
    <a class="product-listing-top__btn js-open-sidebar" href="javascript:;" @click="openSideBar">
      <SvgIcon class="product-listing-top__btn-icon" iconName="ico-sliders-h"/>
      Filters
    </a>
  </div>
</template>

<script>
import PartPills from '../parts/PartPills.vue';
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
import {EventBus} from '@/vue/store';
import Global from '../../../js/_site/global';


export default {
  beforeMount() {
    this.checkFilters();
  },
  components: {
    PartPills,
    SvgIcon
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      countProducts: sapData.productsCount,
      color: [],
      activeFilters: Global.readCookie('activeFilters')
    };
  },
  methods: {
    openSideBar() {
      const sideBarWrap = document.querySelector('.js-sidebar-wrap');
      const body = document.querySelector('body');
      const a = document.getElementsByClassName('btn');
      sideBarWrap.classList.add('opened-sidebar');
      body.classList.add('sidebar-opened');
    },

    closeSideBar() {
      const sideBarWrap = document.querySelector('.js-sidebar-wrap');
      const body = document.querySelector('body');

      sideBarWrap.classList.remove('opened-sidebar');
      body.classList.remove('sidebar-opened');
    },
    checkFilters() {
      const search = Global.getAllUrlParams();
      let arr = [];
      const newFilters = [];
      if (location.search !== '') {


        for (const s in search) {
          // eslint-disable-next-line no-prototype-builtins
          if (search.hasOwnProperty(s)) {
            const split = search[s].split('+');
            for (let i = 0; i < split.length; i++) {
              arr = arr.concat({[s]: split[i]});
            }

          }
        }

        for (let i = 0; i < arr.length; i++) {
          let val = '';
          let name = '';
          for (const a in arr[i]) {
            // eslint-disable-next-line no-prototype-builtins
            if (arr[i].hasOwnProperty(a)) {
              val = arr[i][a];
              name = a;
            }
          }
          const obj = {
            name: name,
            val: val,
            addInfo: '',
            title: name === 'size' ? val : val.replace(/-/g, ' '),
          };

          newFilters.push(obj);
        }
      }
      Global.setCookie('activeFilters', newFilters);
      this.activeFilters = newFilters;
    }
  },
  created() {
    EventBus.$on('active-filters', activeFilters => {
      this.activeFilters = activeFilters;
    });
    EventBus.$on('get-count', count => {
      this.countProducts = count;
    });
  }
};
</script>

<style lang="scss" scoped>
.product-listing-top {
  padding-left: 50px;
  margin-bottom: 27px;

  @include mq($lg) {
    padding-left: 0;
  }

  @include mq($md) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.product-listing-top__title {
  font-size: 11px;
  font-family: $font-second;
  color: $grey;
  margin-bottom: 14px;
  display: block;
}

.product-listing-top__pils-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @include mq($md) {
    margin-bottom: 14px;
    justify-content: center;
  }
}

.product-listing-top__btn {
  display: none;
  padding: 10px 20px 10px 55px;
  font-size: 20px;
  color: $white;
  font-family: $font-second;
  background-color: #999CAA;
  border-radius: 0 13px 13px 0;
  position: fixed;
  left: 0;
  top: 235px;
  z-index: 10;
  transition: $dur ease-in-out;

  @include mq($md) {
    display: inline-block;
  }
}

.product-listing-top__btn-icon {
  color: $white;
  font-size: 20px;
  height: 20px;
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
